"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModals = void 0;
const react_1 = require("react");
var ModalActionEnum;
(function (ModalActionEnum) {
    ModalActionEnum["SHOW_MODAL"] = "SHOW_MODAL";
    ModalActionEnum["HIDE_MODAL"] = "HIDE_MODAL";
})(ModalActionEnum || (ModalActionEnum = {}));
let modalRefCount = 0;
const ModalReducer = (state, action) => {
    switch (action.type) {
        case ModalActionEnum.SHOW_MODAL: {
            modalRefCount++;
            if (modalRefCount === 1) {
                document.body.style.overflow = 'hidden';
            }
            return { modals: [...state.modals, action.payload], open: true };
        }
        case ModalActionEnum.HIDE_MODAL: {
            const modals = state.modals.filter(modal => modal.name !== action.payload);
            modalRefCount--;
            if (modalRefCount === 0) {
                document.body.style.overflow = '';
                document.body.classList.remove('modal-open');
            }
            return { modals, open: modals.length > 0 };
        }
    }
};
const useModals = () => {
    let [state, dispatch] = (0, react_1.useReducer)(ModalReducer, { modals: [], open: false });
    const showModal = (name, modal, closeOnExternalClick = false) => {
        dispatch({ type: ModalActionEnum.SHOW_MODAL, payload: { name, modal, closeOnExternalClick } });
    };
    const hideModal = (name) => {
        const modalName = name && name.length > 0 ? name : state.modals[state.modals.length - 1].name;
        dispatch({ type: ModalActionEnum.HIDE_MODAL, payload: modalName });
    };
    return { modals: state.modals, showModal, hideModal };
};
exports.useModals = useModals;
